<template>
  <div>
    <h1 class="page-title text-center">{{ $t("form.update_information.title") }}</h1>
    <hr>
    <template v-if="user">
      <ValidationForm v-if="isSingleEntity" :currentUser="user"></ValidationForm>
      <MSValidationForm v-if="!isSingleEntity" :currentUser="user"></MSValidationForm>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ValidationForm from '@/components/candidate/ValidationForm'
  import MSValidationForm from '@/components/candidate/MSValidationForm'

  export default {
    name: "UpdateInformation",
    components: { ValidationForm, MSValidationForm },
    data: function() {
      return { user: null }
    },
    computed: {
      ...mapGetters({
        isSingleEntity: 'auth/isSingleEntity',
        currentUser: 'auth/currentUser'
      })
    },
    watch: {
      currentUser: function() {
        this.user = Object.assign({}, this.currentUser)
        this.$store.commit('users/SET_ADDONS', this.user.user_entities)
      }
    },
    mounted: async function() {
      await this.$store.dispatch('auth/getUser')
      this.user = Object.assign({}, this.currentUser)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UpdateInformation.vue